import { RetailApi } from 'api'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { withErrorBoundary, connected, SearchBar } from 'shared'
import { TopLevelPage, ModelGrid } from 'ui'
import useForceUpdate from 'hooks/useForceUpdate'

const Retails = ({ match }) => {
  const queryRef = useRef(RetailApi.paramsFor('index').q)

  const forceUpdate = useForceUpdate()
  const queryDidChange = q => { queryRef.current = q }
  const queryWouldSubmit = () => { forceUpdate() }

  let { id, eventId } = match.params
  let models = RetailApi.kick('index', { q: queryRef.current })

  return (
    <TopLevelPage className="Parks" modelId={eventId || id} base={eventId ? `/retails/${id}` : '/retails'}>
      <div className="row">
        <div className="col-sm-6 col-lg-4 col-xl-3">
          <SearchBar onChange={queryDidChange} onSubmit={queryWouldSubmit} initialQuery={queryRef.current} />
        </div>
      </div>
      <ModelGrid models={models} base={'retails'} />
    </TopLevelPage>
  )
}

Retails.propTypes = {
  match: PropTypes.object
}

export default withErrorBoundary(connected(Retails))
